import { Chip, ChipLabel, ChipBadgeContainer } from "./styles";

const ChipButton = (props) => {
  const { data, index, handleClick } = props;

  const handleChip = () => {
    if (data?.disabled) return;
    handleClick(data, index);
  };

  return (
    <Chip
      focused={data.focused}
      highlight={data.color}
      disabled={data?.disabled}
      onClick={handleChip}
      title={data?.disabled ? "Disabled" : undefined}
      aria-disabled={data?.disabled ? true : undefined}
    >
      <ChipLabel focused={data.focused} disabled={data?.disabled}>
        {data.label}
      </ChipLabel>
      <ChipBadgeContainer focused={data.focused} highlight={data.color} disabled={data?.disabled}>
        {data.count}
      </ChipBadgeContainer>
    </Chip>
  );
};

export default ChipButton;
